/* global eventDelegate:true */

import {
    EMAIL_REGEX,
    validateError,
    validateSuccess
} from '../../checkout/components/cart-functions';

const MODAL_TITLE = '.post-feedback-modal .modal__title';
const SUBMIT_BTN = '.post-feedback-modal .js-submit';

export default class PostFeedback {
    constructor(context) {
        this.context = context;
        this.postId = context.getAttribute('data-post-id');
        this.title = context.getAttribute('data-title');
        this.emailInput = context.querySelector('input[type="email"]');
        this.msgInput = context.querySelector('textarea');

        // если указан email, проверим его сразу
        if (this.emailInput.value) {
            this.validateInput(
                this.emailInput,
                EMAIL_REGEX.test(this.emailInput.value)
            );
        }

        eventDelegate.addEvent('click', SUBMIT_BTN, () => this.onSubmit());
    }

    onSubmit() {
        const email        = this.emailInput.value;
        const emailIsValid = EMAIL_REGEX.test(email);
        const message      = this.msgInput.value;
        const title        = this.title;

        this.validateInput(this.emailInput, emailIsValid);
        this.validateInput(this.msgInput, message);

        if (emailIsValid && message) {
            window.togglePreloader();

            this.saveEmailToCookies(email);

            const url = Routing.generate('api.web.blog.feedback', {
                post: this.postId || 0
            });

            if (!this.postId) {
                url = Routing.generate('api.web.blog.feedback.without.post');
            }
            const formData = MNTK.createFormData({email, message, title});
            MNTK.fetchJson(url, {
                method: 'POST',
                formData
            })
                .then(({ json }) => {
                    this.onRequestSuccess();
                    window.togglePreloader();
                    if (json.newEmailObtained) {
                        MNTK.emit('NEW_EMAIL_OBTAINED');
                    }
                })
                .catch(error => {
                    this.onRequestError(error);
                    window.togglePreloader();
                });
        }
    }

    onRequestSuccess() {
        this.context.classList.add('submitted');
        this.context.innerHTML =
            'Спасибо за обратную связь!<br>Ваше сообщение отправлено руководителю контент-отдела.';

        const $title = document.querySelector(MODAL_TITLE);
        $title && $title.classList.add('hidden');
        const $submitBtn = document.querySelector(SUBMIT_BTN);
        $submitBtn && $submitBtn.classList.add('hidden');
    }

    onRequestError(error) {
        console.log(error);
        window.onModalClose();
        window.openMessageModal(error.message, 'Произошла ошибка!');
    }

    validateInput(input, isValid) {
        isValid ? validateSuccess(input) : validateError(input);

        const parent = input.closest('.form__row');
        if (parent) {
            const error = parent.querySelector('.error');
            error && error.classList.toggle('hidden', isValid);
        }
    }

    saveEmailToCookies(email) {
        MNTK.cookieParse.setEscapedCookie('subscriptionEmail', email, 365);
    }
}
